module.exports = __webpack_public_path__ + "img/service_qr.3fcdf8eb.png";